import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { JobProcessorContainerModel } from "../../../../../models/aggregates/job-processor/job-processor.model";
import { Core2Config } from "../shared/core2Config";
import { HttpClient } from "@angular/common/http";



@Injectable({
    providedIn: 'root'
})

export class JobProcessorService extends BaseApiTemplateService<JobProcessorContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'job-processor-maintenance';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'job-processor-maintenance';
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'job-processor-maintenance';
        this.httpClient = http;
    }
    
}